export default function Mic() {
  return (
    <svg fill='none' height='32' viewBox='0 0 32 32' width='32' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.9999 25.3327C20.1006 25.3327 23.6247 22.8645 25.1679 19.3327M15.9999 25.3327C11.8993 25.3327 8.37514 22.8645 6.83203 19.3327M15.9999 25.3327V28.3327M15.9999 20.9993C12.8703 20.9993 10.3333 18.4623 10.3333 15.3327V9.33268C10.3333 6.20307 12.8703 3.66602 15.9999 3.66602C19.1296 3.66602 21.6666 6.20307 21.6666 9.33268V15.3327C21.6666 18.4623 19.1296 20.9993 15.9999 20.9993Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </svg>
  );
}
